import { Buffer } from 'buffer';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { auth } from './firebase'; // Importa el objeto de autenticación desde firebase.js
import { store } from './app/store'
import { Provider } from 'react-redux'
import { IS_LOCAL, getHealth } from './features/comandas/services/localMode';
import { setUser } from './features/user/userSlice';

if (typeof window !== 'undefined' && !window.Buffer) window.Buffer = Buffer;

function renderApp() {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <Provider store={store}>
      <App auth={auth} />
    </Provider>
  );
}

// Pantalla de arranque del modo local (HTML crudo, antes de montar React). On-brand.
function localBootScreen(inner) {
  return (
    '<div style="font-family:system-ui,-apple-system,sans-serif;background:#111;color:#eee;' +
    'min-height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;' +
    'text-align:center;padding:24px;box-sizing:border-box">' + inner + '</div>'
  );
}

// Dispositivo en la WiFi del local SIN el token de pairing (no escaneó el QR). El agente
// responde /health (abierto) pero /config,/orders,/menu darían 401 → la POS quedaría
// girando en "loading" sin decir nada. En vez de eso mostramos qué hacer: escaneá el QR.
function pairNeededHtml() {
  return localBootScreen(
    '<div style="font-size:56px;line-height:1;margin-bottom:16px">📱</div>' +
    '<h1 style="font-size:22px;color:#FDC029;margin:0 0 12px">Conectá este dispositivo</h1>' +
    '<p style="color:#bbb;line-height:1.6;max-width:340px;margin:0 0 24px;font-size:15px">' +
    'Para entrar a las comandas, escaneá el <b style="color:#eee">código QR</b> del local: ' +
    'en la PC abrí <b style="color:#eee">“Conectar celulares (QR)”</b> y apuntá la cámara al código.</p>' +
    '<button onclick="location.reload()" style="background:#FDC029;color:#111;border:0;border-radius:12px;' +
    'padding:14px 28px;font-size:16px;font-weight:700;cursor:pointer">Ya lo escaneé — reintentar</button>'
  );
}

// MODO LOCAL (servido por el agente en la LAN): no hay login de Firebase. Antes de
// renderizar, traemos ownerUid/menuId del agente e inyectamos un user sintético para
// pasar el gate de auth (App.js) sin internet. En modo NUBE el boot es idéntico a hoy.
async function boot() {
  if (IS_LOCAL) {
    // El body tiene padding-top:70px (hueco del AppBar global fijo). En modo local NO hay
    // AppBar → esa franja quedaba al pedo arriba. La sacamos (y el fondo cae al de la app).
    document.body.style.paddingTop = "0";
    document.body.style.background = "#eeebe6";
    const rootEl = document.getElementById('root');
    if (rootEl) rootEl.innerHTML = localBootScreen(
      '<div style="color:#888;font-size:16px">Conectando con el agente del local…</div>'
    );
    try {
      const h = await getHealth();
      if (h && h.ownerUid) {
        // Sin token válido (no escaneó el QR) → pantalla clara, no loading infinito.
        // authorized===false solo lo devuelve el agente nuevo; si es undefined (agente
        // viejo) seguimos como antes.
        if (h.authorized === false) {
          if (rootEl) rootEl.innerHTML = pairNeededHtml();
          return;
        }
        window.__COMANDAS_LOCAL__ = { ownerUid: h.ownerUid, menuId: h.menuId };
        store.dispatch(setUser({ uid: h.ownerUid, name: 'local', local: true }));
      }
    } catch (_) { /* si el agente no responde, la app cae a su flujo normal */ }
  }
  renderApp();
}

boot();

reportWebVitals();
